import { FC } from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { QcsTypography } from '../../common/basic/QcsTypography';
import { FaIcon } from '../../common/FaIcon';
import { faUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { getFirstLastNameObj, joinStrings } from '../../../utils/format';
import { linkSx } from './styles';

interface PersonLinkProps {
  person: { name?: string; lastName?: string; email?: string; phone?: string } | undefined;
  onClick?: () => void;
  sx?: SxProps<Theme>;
}

export const PersonLink: FC<PersonLinkProps> = ({ person, onClick, sx }) => (
  <Box
    onClick={onClick}
    sx={[
      {
        display: 'flex',
        alignItems: 'center',
        gap: 0.75,
      },
      ...(onClick ? [linkSx] : []),
      ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
    ]}
  >
    <QcsTypography variant="body2" sx={{ color: 'text.secondary', fontSize: '0.85rem' }}>
      {joinStrings(getFirstLastNameObj(person), person?.email, person?.phone)}
    </QcsTypography>
    {onClick && <FaIcon icon={faUpRightFromSquare} width={11} height={11} style={{ opacity: 0.4, flexShrink: 0 }} />}
  </Box>
);
